import { useEffect, useState } from "react";
import { CustomError } from "../http/errors";

/*

Because SWR, when validating and reloading, sets the result to null, this hook is needed to keep the previous data.
Used for tables data, in order to improve UI/UX. Withoutm when saving a record, the tables gets in loading mode.

*/

const useDataInitializer = <T>(data?: T, error?: CustomError): [T | undefined, boolean] => {
  const [state, setState] = useState<{
    data: T | undefined;
    isInitialized: boolean;
  }>({
    data: data,
    isInitialized: false,
  });

  useEffect(() => {
    setState((prev) => ({
      data: !error ? (data ?? prev.data) : undefined,
      isInitialized: !!prev.data || !!data || !!error,
    }));
  }, [data, error]);

  return [state.data, state.isInitialized];
};

export default useDataInitializer;
